// frontend/src/pages/learning/AssignmentTopicList.js
const modules = [
  { 
    owner:'Think5Whys', 
    code: 't5was101', 
    sn:'1', 
    title: 'Overcoming Procrastination', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Uncover the root causes behind procrastination and create an actionable plan for improvement.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was102', 
    sn:'2', 
    title: 'Decision-Making Dilemmas', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: ' Analyze a specific decision you struggled with, identify the underlying challenges, and develop insights for future choices.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was103', 
    sn:'3', 
    title: 'Work-Life Balance', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Investigate the factors affecting your work-life balance and propose strategies to achieve a more harmonious lifestyle.'
  },
  { 
    owner:'Think5Whys', 
    code: 't5was104', 
    sn:'4', 
    title: 'Goal Setting and Achievement', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Examine your past goals, understand any impediments faced, and refine your approach to goal setting for future success.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was105', 
    sn:'5', 
    title: 'Communication Challenges', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Explore instances where communication breakdowns occurred, delve into the reasons, and propose ways to enhance communication effectiveness.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was106', 
    sn:'6', 
    title: 'Deteriorating Academic Performance', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Examine the factors contributing to your underperformance in a particular exam or contest compared to your expectations. Uncover the root causes, and strategize ways to prevent its recurrence in the future.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was106', 
    sn:'7', 
    title: 'Job Insecurity', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Examine the factors contributing to job insecurity for self of any other person. Uncover the root causes, and strategize ways to mitigate or reduce its impact.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was106', 
    sn:'8', 
    title: 'Declinig Sales', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Examine the factors contributing poor business outlook mostly declining sales. Uncover the root causes and strategize ways to mitigate or reduce its impact.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was106', 
    sn:'9', 
    title: 'Decreasing Profitability', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Concern', 
    desc: 'Examine the factors contributing declining profitability in spite of increase in revenue. Uncover the root causes and strategize ways to mitigate or reduce its impact.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was601', 
    sn:'1', 
    title: 'Entrepreneurial Dreams', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Goal', 
    desc: 'Express your desire to start a business including setting up own factory. Use Think5Whys DIY assignment workbook to uncover the motivations and potential obstacles behind your entrepreneurial goal, helping you refine your strategy.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was602', 
    sn:'2', 
    title: 'Gaming Enthusiast Path', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Goal', 
    desc: 'Share your ambition to become a professional gamer. Use Think5Whys DIY assignment workbook to explore the underlying factors influencing your gaming aspirations, guiding you to make informed decisions for skill development.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was603', 
    sn:'3', 
    title: 'Professional Aspiration', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Goal', 
    desc: 'Communicate your goal to become a professional like engineer, doctor, lawyer, financial advisor, coach, sportsperson etc. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones for your professional career.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was604', 
    sn:'4', 
    title: 'Blogger or YouTuber Aspiration', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Goal', 
    desc: ' Communicate your goal to become a YouTuber or like. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones to become a blogger or YouTube career.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was605', 
    sn:'5', 
    title: 'Becoming a Social Worker', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Goal', 
    desc: 'Communicate your goal to become a social worker or reformist. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones to become a social worker or like.' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5was605', 
    sn:'6', 
    title: 'Becoming a Sportsperson', 
    landingPageUrl: '/assignment/add', 
    topictype: 'Goal', 
    desc: 'Communicate your goal to become a Sports person. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones to become a Sports person.' 
  },
];

export default modules;

